<template>
  <div class="signup-button"  @click="onGoogleSignUp">
    <rt-picture class="provider-icon" :src="providerIcon" :autosize="false"/>
    <div class="signup-button__text">
      <span>Sign up with {{provider.charAt(0).toUpperCase() + provider.slice(1)}}</span>
    </div>
  </div>
</template>

<script>
  import RTGoogleAnalyticsManager from '../../../../common/RTGoogleAnalyticsManager';
  import Utils from '../../../../common/Utils';
  import RtPicture from "../../common/Picture.vue";

  export default {
    components: {RtPicture},
    props: ['role', 'classcode', 'refcode', 'provider', 'action'],
    computed: {
      timezone() {
        return Utils.getTimeZoneFromBrowser();
      },
      loginUrl() {
        return `/v2/auth/${this.provider}/${this.action}?provider=${this.provider}&register=${this.role}&classcode=${this.classcode}${this.refcode ? '&ref=' + this.refcode : ''}${this.timezone ? '&tz=' + this.timezone : ''}`
      },
      providerIcon() {
        return {
          'google': '/assets/app/signup/google-icon.svg',
          'microsoft': '/assets/app/signup/microsoft-icon.svg',
          'clever': '/assets/app/signup/clever-icon.png',
          'classlink': '/assets/app/signup/classlink-icon.png'
        }[this.provider];
      },
    },
    methods: {
      onGoogleSignUp() {
        RTGoogleAnalyticsManager.sendEvent(this.provider, 'create_account', this.role);
        localStorage.setItem('rt-signup-role', this.role);
        window.location.href = this.loginUrl;
      }
    }
  }

</script>

<style scoped lang="scss">
  @import '../../common/variables';

  .signup-button {
    border: 2px solid $border-hover-blue;
    border-radius: 30px;
    margin: 8px;
    color: #498BF9;
    font-weight: 800;
    font-size: 14px;
    display: flex;
    justify-content: center;
    height: 46px;
    min-width: 280px;
    cursor: pointer;

    &:hover {
      border: 2px solid $primary-dark-blue;
    }

    .signup-button__text {
      margin: auto 7px;
    }

    .provider-icon {
      height: 16px;
      margin: auto 0;
    }

  }

</style>
